import * as React from 'react'
import { FaCloudUploadAlt as CloudUploadIcon } from '@react-icons/all-files/fa/FaCloudUploadAlt'
import { useTranslation } from '@disco/i18n/use-translation'
import styles from './index.module.css'

type Props = {
  targetText?: string
}

const FileDropOverlay = ({ targetText }: Props): React.ReactElement<'div'> => {
  const { t } = useTranslation('inboxes')

  return (
    <div className={styles.fileDropOverlayCont}>
      <div className={styles.fileDropOverlayIcon}>
        <CloudUploadIcon />
      </div>
      {/* Two whole sentences rather than a shared prefix plus a trailing
          "to {{targetText}}" fragment: a fragment cannot be reordered, so ja/ko
          could not be translated correctly. */}
      <span>
        {targetText
          ? t(
              'inboxes:dragFilesToUploadToTarget',
              'Drag files to upload them instantly to {{targetText}}',
              { targetText },
            )
          : t(
              'inboxes:dragFilesToUpload',
              'Drag files to upload them instantly',
            )}
      </span>
    </div>
  )
}

export default FileDropOverlay
